import { TopNavBar } from '@ui/layouts/components/TopNavBar';
import { Flex } from 'styled-system/jsx';

export const TradePairPanel = () => {
  return (
    <Flex
      flexDirection="column"
      w={{
        base: '100%',
        desktop: 'auto',
      }}
      display={{
        base: 'flex',
        desktop: 'flex',
      }}
    >
      <TopNavBar />
    </Flex>
  );
};
